import styled from '@emotion/styled'

import { Container } from '@paypalcorp/pp-react'

export const LoadingContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`
